/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
import moment from 'moment';
import helper from '@/_libs/helper';

const DATE_TODAY = moment().format('YYYY-MM-DD');

const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const MOCK = {
  product: {
    categories: [
      { id: '01', name: 'ไม้อัดพิเศษ' },
      { id: '02', name: 'ไม้อัดธรรมดา' },
      { id: '03', name: 'ไม้แปรรูป' },
      { id: '04', name: 'กระดาษอัด' },
      { id: '05', name: 'ประตู' },
      { id: '06', name: 'บอร์ดหนา' },
      { id: '07', name: 'บอร์ดเคลือบ/ไฟเมก้า' },
      { id: '08', name: 'ลวด' },
      { id: '09', name: 'ตะปู/ตะขอ' },
      { id: '10', name: 'สังกะสี/โลหะแปรรูป' },
      { id: '11', name: 'อลูมีเนียม/อุปกรณ์' },
      { id: '12', name: 'ซีไลน์/เหล็กขึ้นรูป' },
      { id: '13', name: 'เคมี/น้ำยา' },
      { id: '99', name: 'เบ็ดเตล็ด' },
    ],
    subCategories: [
      { id: '01', name: 'ไม้อัดยางไส้ไม้' },
      { id: '02', name: 'ไม้อัดยางไส้ MDF' },
      { id: '03', name: 'ไม้อัดยางไส้ปาร์ติเคิล' },
      { id: '04', name: 'ไม้อัดแบบเคลือบฟิล์ม' },
      { id: '05', name: 'ไม้พื้นเตียง' },
      { id: '99', name: 'ไม้อัดธรรมดาอื่นๆ' },
    ],
    list: [
      {
        productCode: 'AAAA',
        productName: 'ซีลาย #26',
        unit: 'เส้น',
        bigUnit: 'เส้น',
        category: {
          id: '01',
        },
        amountInOneBigUnit: 1,
        weight: 12,
        latestSellPrice: 4.2, // of this customer
        levels: [ /* eslint-disable */
          { sellPriceMin: 4.00, sellPriceMax: 4.25, commission: { amount: 0.02, isPercent: true } },
          { sellPriceMin: 5.25, sellPriceMax: 5.50, commission: { amount: 0.05, isPercent: true } },
          { sellPriceMin: 5.51, sellPriceMax: 6.00, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 6.01, sellPriceMax: 6.25, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 6.26, sellPriceMax: 6.50, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 7.25, sellPriceMax: 7.50, commission: { amount: 1.25, isPercent: false } },
          { sellPriceMin: 8.25, sellPriceMax: 8.50, commission: { amount: 1.5, isPercent: false } },
        ],
      },
      {
        productCode: 'BBAA',
        productName: 'ซีลาย #27',
        unit: 'เส้น',
        bigUnit: 'มัด',
        category: {
          id: '01',
        },
        image: 'http://placekitten.com/128/128',
        amountInOneBigUnit: 30,
        weight: 100,
        latestSellPrice: 2.2, // of this customer
        levels: [ /* eslint-disable */
          { sellPriceMin: 4.00, sellPriceMax: 4.25,commission: { amount: 0.25, isPercent: false } },
          { sellPriceMin: 5.25, sellPriceMax: 5.50, commission: { amount: 0.05, isPercent: true } },
          { sellPriceMin: 5.51, sellPriceMax: 6.00, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 6.01, sellPriceMax: 6.25, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 6.26, sellPriceMax: 6.50, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 7.25, sellPriceMax: 7.50, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 8.25, sellPriceMax: 8.50, commission: { amount: 1.5, isPercent: false } },
        ],
      },
      {
        productCode: 'BBAC',
        productName: 'ซีลาย #2000',
        unit: 'เส้น',
        bigUnit: 'มัด',
        category: {
          id: '01',
        },
        image: 'http://placekitten.com/128/128',
        amountInOneBigUnit: 30,
        weight: 45,
        latestSellPrice: 2.2, // of this customer
        levels: [ /* eslint-disable */
          { sellPriceMin: 4.00, sellPriceMax: 4.25,commission: { amount: 0.25, isPercent: false } },
          { sellPriceMin: 5.25, sellPriceMax: 5.50, commission: { amount: 0.05, isPercent: true } },
          { sellPriceMin: 5.51, sellPriceMax: 6.00, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 6.01, sellPriceMax: 6.25, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 6.26, sellPriceMax: 6.50, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 7.25, sellPriceMax: 7.50, commission: { amount: 1, isPercent: false } },
          { sellPriceMin: 8.25, sellPriceMax: 8.50, commission: { amount: 1.5, isPercent: false } },
        ],
      },
    ],
    
    stat: {
      byCategories: [
        {
          date: DATE_TODAY,
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          date: DATE_TODAY,
          productId: '3D6XN5C',
          productName: 'ประตูไม้อัด ตรากระต่าย',
          quantity: 2,
          price: 6000.04,
          total: 6000.04 * 2,
        },
        {
          date: DATE_TODAY,
          productId: 'H8TD5IA2',
          productName: 'ไม้อัดลายอิตาลี ตรากระต่าย',
          quantity: 10,
          price: 6000.04,
          total: 6000.04 * 10,
        },
        {
          date: DATE_TODAY,
          productId: '0SR674D',
          productName: 'ไม้อัด 3 ชั้น',
          quantity: 7,
          price: 6000.04,
          total: 6000.04 * 7,
        },
        {
          date: DATE_TODAY,
          productId: 'M0SR123',
          productName: 'ไม้อัดเรียบตัดขอบ',
          quantity: 5,
          price: 6000.04,
          total: 6000.04 * 5,
        },
      ],
      byProducts: [
        {
          date: DATE_LASTWEEK,
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 12,
          price: 6000.04,
          total: 72000.48,
        },
        {
          date: DATE_YESTERDAY,
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 2,
          price: 5555,
          total: 5555 * 2,
        },
        {
          date: DATE_3_DAYS_AGO,
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 10,
          price: 1249.04,
          total: 1249.04 * 10,
        },
        {
          date: DATE_TODAY,
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          quantity: 5,
          price: 9000.04,
          total: 9000.04 * 5
        },
      ],
    },
  },
};

const product = {
  async getCategories() {
    return await helper.call('product.getCategories', {
      success: true,
      data: MOCK.product.categories,
    }, async () => await axios(helper.path('products/groups')));
  },
  async getSubCategories(catId) {
    return await helper.call('product.getSubCategories', {
      success: true,
      data: MOCK.product.subCategories,
    }, async () => await axios(helper.path(`products/group/${catId}/types`)));
  },
  async getLevel(prodId, customerGrade) {
    return await helper.call('product.getLevel', {
    }, async () => {
      const res = await axios(helper.path(`products/${prodId}`), { params: { grade: customerGrade } });
      res.data = res.data.map(elm => ({
        sellPriceMin: parseFloat(elm.price_min),
        sellPriceMax: parseFloat(elm.price_max),
        commission: {
          amount: parseFloat(elm.commission),
          isPercent: (elm.is_percent == 'true' || elm.is_percent == 1),
        }, 
      }));
      return res;
    });
  },
  async search(searchStr, custId = -1, page = 1) {
    return await helper.call('product.search', {
      success: true,
      data: MOCK.product.list,
    }, async () => {

      let params = {
        'page[number]': page,
      };
        if (custId !== -1) params.customer_id = custId;
      if (/^\d+$/.test(searchStr)) {
        params.product_id = searchStr
      } else {
        params.name = searchStr
      }

      let res = await axios(helper.path(`products/search`), {
        params,
      });
      res = helper.dataMap(res, elm => ({
        productCode: elm.id,
        productName: elm.name,
        unit: elm.unit,
        bigUnit: elm.display_unit,
        amountInOneBigUnit: elm.amount_per_unit,
        weight: elm.weight,
        latestSellPrice: '<latestSellPrice>',
        levels: [],
      }));
      return res;
    });
  },
  async listBySubCategory(catId, subCatId, custId, page = 1) {
    return await helper.call('product.listBySubCategory', {
      success: true,
      data: MOCK.product.list,
    }, async () => {
      let res;
      if (catId === 'all') {
        res = await axios(helper.path(`products/search`));
      } else {
        res = await axios(helper.path(`products/search?group_id=${catId}&type_id=${subCatId}&customer_id=${custId}&page[number]=${page}`));
      }
      console.log('SUB-CAT');
      console.log(res);
      res = helper.dataMap(res, elm => ({
        productCode: elm.id,
        productName: elm.name,
        unit: elm.unit,
        bigUnit: elm.display_unit,
        amountInOneBigUnit: elm.amount_per_unit,
        weight: elm.weight,
        latestSellPrice: elm.latest_price,
        levels: [],
      }));
      return res;
    });
  },
  async listWithPrices(customerGrade, page = 1, searchKeyword) {
    return await helper.call('product.listWithPrices', {
      success: true,
      data: MOCK.product.list,
    }, async () => {
      const ENDPOINT = helper.path(
        searchKeyword ? 'products/search' : 'products/prices',
      );
      const params = { 
        grade: customerGrade,
        'page[number]': page,
        name: searchKeyword ? searchKeyword : undefined,
      };
      const res = await axios(ENDPOINT, { params });
      return res;
    });
  },
  // async listForAdmin() {
  //   return await helper.call('product.listForAdmin', {
  //     success: true,
  //     data: MOCK.product.list,
  //   }, async () => await axios(helper.path('admin/product/')));
  // },
  // async categoryStat(catId, custId) {
  //   return await helper.call('product.categoryStat', {
  //     success: true,
  //     data: MOCK.product.stat.byCategories,
  //   }, async () => await axios(helper.path('product/categories/stat/', { query: { catId, custId } })));
  // },
  async productStat(prodId, custId, from, to, page = 1) {
    return await helper.call('product.productStat', {
      success: true,
      data: MOCK.product.stat.byProducts,
    }, async () => {
      const res = await axios(helper.path(`products/${prodId}/orders`, { 
        // query: { prodId, custId } 
        params: {
          customer_id: custId,
          from: from ? moment(from).format('YYYY-MM-DD HH:mm:ss') : undefined,
          to: to ? moment(to).format('YYYY-MM-DD HH:mm:ss') : undefined,
          'page[number]': page,
        }
      }));
      res.data.data = res.data.data.map(elm => ({
        ...elm,
        
        date: elm.created_at,
        productId: elm.product_id,
        productName: elm.product ? elm.product.name : '-',
      }))
      return res;
    });
  },
  
  async uploadPriceFiles(formData) {
    return await helper.call('product.uploadPriceFiles', {
      // ...
    }, async () => await axios.post(helper.path('products/prices'),
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }));
  },
};

export default {
  ...product,
  COL_TYPE: {
    Amount: 'PRODUCT_AMOUNT',
  },
};
